import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=ee20c8da&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee20c8da')) {
      api.createRecord('ee20c8da', component.options)
    } else {
      api.reload('ee20c8da', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=ee20c8da&", function () {
      api.rerender('ee20c8da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Fb6sMGiCAU3P/JS/offershelp.vue"
export default component.exports